import { defineDirective, FieldViewModel, IOmniaShell, shell } from "../../omnia"
import { ISoilService, LayerTypeId } from "../../types"
import { SoilMapContext } from "../map/context"
import { IDashboardContext } from "../types"
import { PcnAnalysisVM } from "./pcn-vm"

export class PcnAnalysisTableCtrl {

    static create(): ng.IDirective {
        return defineDirective(PcnAnalysisTableCtrl, "app/soil/dashboard/pcn/pcn.html", {
            context: "="
        });
    }

    public readonly readOnly = this.shell.isReadOnly(p => p.soil)

    private context: IDashboardContext;

    public map: SoilMapContext;
    public selectedField: FieldViewModel;

    public pcnAnalysis: PcnAnalysisVM[];

    showPcnAnalysisHistory: boolean;

    static $inject = ["$scope", "OmniaSoilService", "OmniaShell"];

    constructor($scope: ng.IScope, private svc: ISoilService, private shell: IOmniaShell) {

        $scope.$watch("vm.context", () => this.setup());

    }

    private setup() {

        this.map = null
        this.selectedField = null
        this.pcnAnalysis = null

        if (!this.context) return

        this.map = this.context.map
        this.selectedField = this.context.selectedField
        const selectedZone = this.context.selectedZone
        const pcnAnalysisLayers = (this.context.layers || []).filter(l => l.TypeId == LayerTypeId.PcnAnalysis)

        if (this.selectedField) {

            let currentViewKey = this.map.group ? this.map.group.key : null;

            let selectedZoneId = selectedZone ? selectedZone.zone.DataLayerZoneId : null;

            let pcnAnalysis = PcnAnalysisVM.create(this.svc, pcnAnalysisLayers, this.selectedField, selectedZoneId, currentViewKey == "P");

            if (pcnAnalysis) {

                this.pcnAnalysis = pcnAnalysis;

            }

        }

    }

    private selectPcnAnalysis(a: PcnAnalysisVM, element?: string) {


        let field = this.selectedField;

        this.map.selectView("P", element);

        let zone = a.zone ? this.map.getZoneFromCurrentView(a.zone.DataLayerZoneId) : null;
        this.context.setSelectedField(field, zone, true);

    }

    private allocAnalysis() {

        this.shell.showComponentAsDialog("omnia-soil-pcn-alloc-popup", this.selectedField, {
            backdrop: "static",
            size: "xlarge"
        }).then(r => {
            this.context.refresh();
        });

    }

    unAllocAnalysis(vm: PcnAnalysisVM) {

        var msg = "You are about to unallocate this PCN analysis from the field " + this.selectedField.description + ". Are you sure ?";

        shell.showDeleteCancel(this.shell, msg, "Unallocate").then(r => {
            if (r) {
                this.svc.unallocPcnAnalysis(vm.analysis.PcnAnalysisId, this.selectedField.fieldId)
                    .then(r => this.context.refresh());
            }
        });

    }

    private editPcnAnalysis(vm: PcnAnalysisVM) {

        let cmd = {
            analysis: vm ? vm.analysis : null,
            edit: true,
            alloc: this.selectedField
        };

        this.context.showDialog("omnia-soil-editor-pcn-popup", cmd);

    }

    private createPcnAnalysis() {
        this.editPcnAnalysis(null);
    }

    private hasHistoricalPcnAnalysis() {
        return this.pcnAnalysis && this.pcnAnalysis.some(s => !s.current);
    }


}
